exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".notificator__notificator___17qi3{position:relative;padding:10px 5px;margin-bottom:20px}.notificator__notificator___17qi3 section{max-width:75%}.notificator__notificator___17qi3 section header{margin-bottom:5px;font-size:18px;font-weight:700}.notificator__notificator___17qi3 section p{margin:0;text-align:left;opacity:1}.notificator__notificator___17qi3 img{display:none}@media (min-width:768px){.notificator__notificator___17qi3{padding:30px 20px}.notificator__notificator___17qi3 img{display:block;position:absolute;right:25px;bottom:0;height:130px}}.notificator__error___1flcP{background-color:#f3dff1;color:#af2d9c}.notificator__error___1flcP h1{color:#af2d9c}.notificator__info___3d2wL{background-color:#e9f2f6;color:#00aeef}.notificator__info___3d2wL img{bottom:-6px}.notificator__success___3WfCG{background-color:#eaffdf;color:#62aa26}.notificator__success___3WfCG img{bottom:-6px}", ""]);

// exports
exports.locals = {
	"notificator": "notificator__notificator___17qi3",
	"error": "notificator__error___1flcP",
	"info": "notificator__info___3d2wL",
	"success": "notificator__success___3WfCG"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/components/styles/notificator.scss
// module id = 1072
// module chunks = 0